import React from 'react';
import { Spacer, SpacerProps } from '@qbe/ads-core';

export type FormSpacerType = 'pagesection' | 'formgroup' | 'input';

export type FormSpacerProps = {
  type: FormSpacerType;
  direction?: SpacerProps['direction'];
};

type MapTypeResult = {
  overrides: SpacerProps['breakpointsOverride'];
  size: SpacerProps['size'];
};

function mapType(type: FormSpacerType): MapTypeResult {
  switch (type) {
    case 'pagesection':
      return { overrides: { mobile: { size: 'md' } }, size: 'md' };
    case 'formgroup':
      return { overrides: { mobile: { size: 'xl' } }, size: 'xl' };
    case 'input':
      return { overrides: { mobile: { size: 'md' } }, size: 'md' };
  }
}

const FormSpacer = ({ type, direction = 'column' }: FormSpacerProps) => {
  const sizes = mapType(type);
  return <Spacer breakpointsOverride={sizes.overrides} size={sizes.size} direction={direction} />;
};

export default FormSpacer;
